import { useState } from "react";
import { env } from "@/config/environment-vars";

class CustomerIDRepository {
  private readonly localStorageKey = env.VITE_CUSTOMER_ID_KEY;

  public getCustomerID(): number | undefined {
    const customerId = localStorage.getItem(this.localStorageKey);
    try {
      return customerId ? Number.parseInt(customerId, 10) : undefined;
    } catch (error) {
      console.error("Error parsing customer ID from localStorage:", error);
      localStorage.removeItem(this.localStorageKey);
      return undefined;
    }
  }

  public setCustomerID(customerId: number | null): void {
    if (customerId === null) {
      localStorage.removeItem(this.localStorageKey);
      return;
    }

    localStorage.setItem(this.localStorageKey, customerId.toString());
  }
}

export const useCustomerID = () => {
  const repository = new CustomerIDRepository();

  const [customerID, setCustomerIDState] = useState<number | undefined>(repository.getCustomerID());

  return {
    customerID,
    setCustomerID(customerId: number) {
      repository.setCustomerID(customerId);
      setCustomerIDState(customerId);
    },
  };
};
